<script>
import { Bar } from 'vue-chartjs'

export default {
  name: 'BarChart',
  extends: Bar,
  props: {
    data: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => {}
    },
    gradient: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chartData() {
      return this.data
    }
  },
  watch: {
    data() {
      this._data._chart.destroy()
      this.renderBarChart()
    }
  },
  mounted() {
    this.renderBarChart()
  },
  methods: {
    renderBarChart() {
      const plugin = {
        afterLayout: chart => {
          const ctx = chart.chart.ctx
          ctx.save()
          const yAxis = chart.scales['y-axis-0']
          const yBottom = yAxis.getPixelForValue(0)
          const yTop = yAxis.getPixelForValue(5)
          const gradient = ctx.createLinearGradient(0, yBottom, 0, yTop)
          gradient.addColorStop(0, 'rgba(225, 245, 254, 0.7)')
          gradient.addColorStop(1, 'rgba(1, 87, 155, 0.7)')
          chart.data.datasets[0].backgroundColor = gradient
          ctx.restore()
        }
      }
      this._data._plugins.push(plugin)
      this.renderChart(this.data, this.options)
    }
  }
}
</script>
